import React, { PropTypes, Component } from 'react';

class LiveInputField extends Component {
  static propTypes = {
    style: PropTypes.object,
    onChange: PropTypes.func,
    leftIcon: PropTypes.node,
    rightIcon: PropTypes.node
  };

  static contextTypes = {
    muiTheme: PropTypes.object
  };

  componentWillMount() {
    let {textField} = this.context.muiTheme;
    this.style = {
      border: `solid 1px ${textField.borderColor}`,
      boxSizing: 'border-box',
      color: textField.textColor,
      fontSize: textField.textSize,
      padding: 15
    }
  }

  render() {
    let {style, onChange,leftIcon, rightIcon, ...otherInputParams} = this.props;

    let newOtherInputParams = Object.assign({}, otherInputParams);
    delete newOtherInputParams.initialValue;
    delete newOtherInputParams.onUpdate;
    delete newOtherInputParams.valid;
    delete newOtherInputParams.invalid;
    delete newOtherInputParams.dirty;
    delete newOtherInputParams.pristine;
    delete newOtherInputParams.error;
    delete newOtherInputParams.active;
    delete newOtherInputParams.touched;
    delete newOtherInputParams.visited;
    delete newOtherInputParams.autofill;
    delete newOtherInputParams.autofilled;

    let changeFunc = (event) => {
      onChange(event.target.value);
    };

    style = Object.assign(this.style, style);

    return (
      <div>
        {leftIcon ? (<span style={{position:'relative'}}>{leftIcon}</span>) : null}
        <input style={style} onChange={changeFunc} {...newOtherInputParams}/>
        {rightIcon ? (<span style={{position:'relative'}}>{rightIcon}</span>) : null}
      </div>
    );
  }
}

export default LiveInputField;





// WEBPACK FOOTER //
// ./src/components/form/Input/LiveInputField.js